import React, { lazy, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import LoadingPage from '../../pages/presentation/auth/LoadingPage';
import ForbiddenPage from '../../pages/presentation/auth/ForbiddenPage';
import { demoPagesMenu } from '../../menu';
import Page404 from '../../pages/presentation/auth/Page404';
const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

const ContentRoutes = () => {
	const [isAccess, setIsAccess] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();

	const [loading, setLoading] = useState(true);
	const [forbidden, setForbidden] = useState(false);

	var localData: any;
	if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
		localData = JSON.parse(localStorage.getItem('userData') || '');
	}

	useEffect(() => {
		if (localStorage.getItem('userData') == null || localStorage.getItem('userData') == '') {
			navigate(`../${demoPagesMenu.login.path}`);
		}
	}, []);

	const getUserAccess = async (pathName: any) => {
		setLoading(true);

		await fetch(`${process.env.REACT_APP_NODEJS_URL}permissions/get_permissions_data`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				// branch: localData.branch.id,
				company: localData.company.id,
				division: localData.division.id,
				designation: localData.designation.id,
				path: pathName.endsWith('/') ? pathName.slice(1) : pathName,
			}),
		})
			.then(async (response) => {
				const result = await response.json();

				if (result.data.length > 0) {
					setLoading(false);
					setIsAccess(true);
				} else {
					setLoading(false);
					setIsAccess(false);
					setForbidden(true);
				}
			})
			.catch((err) => {
				console.error('error:', err);
				setLoading(false);
			});
	};

	const checkToolCustomizationAccess = async () => {
		setLoading(true);

		await fetch(`${process.env.REACT_APP_NODEJS_URL}permissions/get_permissions_data`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				company: localData.company.id,
				division: localData.division.id,
				designation: localData.designation.id,
			}),
		})
			.then(async (response) => {
				const result = await response.json();

				// Check if any tool customization sub path exists
				const hasAccess = result.data.some((item: any) =>
					item.module_name.startsWith('/tool-customization/')
				);

				if (hasAccess) {
					setIsAccess(true);
				} else {
					setIsAccess(false);
					setForbidden(true);
				}

				setLoading(false);
			})
			.catch((err) => {
				console.error('error:', err);
				setLoading(false);
			});
	};

	useEffect(() => {
			setForbidden(false);
			const pathName = location.pathname;

			if (pathName == '' || pathName == '/' || pathName=='/change-password') {
				setIsAccess(true);
				setLoading(false);
			} else if (
				location.pathname.includes('login') &&
				(localStorage.getItem('userData') == null || localStorage.getItem('userData') == '')
			) {
				setIsAccess(true);
				setLoading(false);
			} else if (
				location.pathname.includes('/login') &&
				(localStorage.getItem('userData') != null || localStorage.getItem('userData') != '')
			) {
				setIsAccess(true);
				navigate('/');
				setLoading(false);
			} else if (
				localStorage.getItem('userData') != '' &&
				localStorage.getItem('userData') != null
			) {
				var localData = JSON.parse(localStorage.getItem('userData') || '');
				if (
					localData.designation.name == 'SuperAdmin' ||
					localData.designation.name == 'superadmin' ||
					localData.designation.name == 'Super Admin'
				) {
					setIsAccess(true);
					setLoading(false);
				} else if (pathName == '/add-edit-export' || pathName == '/add-edit-export-documentation') {
					setIsAccess(true);
					setLoading(false);
				} else {
					// Special case for Tool Customization Main
					if (pathName === '/tool-customization-main') {
						checkToolCustomizationAccess();
					} else {
						getUserAccess(pathName);
					}
				}
			}
	}, [location]);

	if (loading) {
		return <LoadingPage />;
	}

	if (forbidden) {
		return <ForbiddenPage />;
	}

	return isAccess ? (
		<Routes>
			{contents.map(
				(page) => (
					<Route key={page.path} {...page} />
				),
				// <Route key={page.path} {...page} />
			)}
			<Route path='*' element={<LoadingPage />} />
		</Routes>
	) : (
		<Routes>
			{contents.map((page) => (
				<Route />
			))}
			<Route path='*' element={<ForbiddenPage />} />
			{/* <Route path='*' element={<PAGE_404 />} /> */}
		</Routes>
	);
};

export default ContentRoutes;
